import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injector } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { WebcamComponent } from './webcam/webcam.component';
import { CommonModule } from '@angular/common';
import { SkisporetComponent } from './skisporet/skisporet.component';
import { HttpClientModule } from '@angular/common/http';
import { FbFeedComponent } from './fbfeed/fbfeed.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCarouselModule } from '@ngmodule/material-carousel';
import { MatIconModule } from '@angular/material/icon';
import { WeatherForecastComponent } from './weather-forecast/weather-forecast.component';
import { WeatherStationComponent } from './weather-station/weahter-station.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [FbFeedComponent, WebcamComponent, WeatherForecastComponent, WeatherStationComponent, SkisporetComponent],
  imports: [BrowserModule, CommonModule, HttpClientModule, BrowserAnimationsModule, MatIconModule, MatCarouselModule.forRoot(), MatTooltipModule],
  entryComponents: [FbFeedComponent, WebcamComponent, WeatherForecastComponent, WeatherStationComponent, SkisporetComponent]
})

export class AppModule {
  constructor(private injector: Injector) {
    customElements.define('webcam-element', createCustomElement(WebcamComponent, { injector }));
    customElements.define('weather-forecast', createCustomElement(WeatherForecastComponent, { injector }));
    customElements.define('weather-station', createCustomElement(WeatherStationComponent, { injector }));
    customElements.define('skisporet-element', createCustomElement(SkisporetComponent, { injector }));
    customElements.define('fbfeed-element', createCustomElement(FbFeedComponent, { injector }));
  }

  ngDoBootstrap() {}
}